export class BalanceSheetCategory {
  id = -1;
  name = '';

  toString(): string {
    return JSON.stringify(this);
  }
}

export const NON_MATURITY_DEPOSIT_INDEX = 4;
export const NON_MATURITY_DEPOSIT_NET_CHANGE_INDEX = 13;
export const AUXILIARY_ASSET_INDEX = 11;
export const AUXILIARY_LIABILITY_INDEX = 12;
